import Box from "@mui/material/Box";
import { cloneDeep } from "lodash";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BooleanSetting from "components/SettingFields/atoms/BooleanSetting";
import InputSetting from "components/SettingFields/atoms/InputSetting";
import TimeBetweenSetting from "components/SettingFields/molecules/TimeBetweenSetting";

const componentTypeMap = {
  toggle: {
    Component: BooleanSetting,
  },
  input: {
    Component: InputSetting,
  },
  "time-between": {
    Component: TimeBetweenSetting,
  },
};

function SyncFrequencySetting({ setting, setParentState }) {
  const toggleDependencies = setting.field_value.reduce((dependencyMap, fieldValue) => {
    if (fieldValue.toggle_dependencies) {
      dependencyMap[fieldValue.en_field_label] = fieldValue.toggle_dependencies;
    }
    return dependencyMap;
  }, {});

  return (
    <Box sx={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
      <Accordion
        sx={{
          width: "100%",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{setting.en_field_label}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {setting.field_value.map((syncFrequencyOption, syncFrequencyOptionIndex) => {
            if (componentTypeMap[syncFrequencyOption.component_field_type]) {
              const ComponentToRender =
                componentTypeMap[syncFrequencyOption.component_field_type].Component;
              return (
                <ComponentToRender
                  setting={syncFrequencyOption}
                  key={syncFrequencyOption.en_field_label}
                  setParentState={(newValue, nestedKey = "") => {
                    const clone = cloneDeep(setting.field_value);
                    let currentlyHandledFieldLabel = "";
                    if (nestedKey) {
                      clone[syncFrequencyOptionIndex].field_value[nestedKey] = newValue;
                      currentlyHandledFieldLabel =
                        clone[syncFrequencyOptionIndex].field_value.en_field_label;
                    } else {
                      clone[syncFrequencyOptionIndex].field_value = newValue;
                      currentlyHandledFieldLabel = clone[syncFrequencyOptionIndex].en_field_label;
                    }
                    // handle for toggle dependencies
                    if (toggleDependencies[currentlyHandledFieldLabel]) {
                      const dependentIndexes = clone.reduce((cloneIndexes, field, cloneIndex) => {
                        const foundFieldIndex = toggleDependencies[
                          currentlyHandledFieldLabel
                        ].findIndex(
                          (dependentField) => dependentField.en_field_label === field.en_field_label
                        );
                        if (foundFieldIndex !== -1) {
                          cloneIndexes.push(cloneIndex);
                        }
                        return cloneIndexes;
                      }, []);

                      dependentIndexes.forEach((index) => {
                        clone[index].field_value = !newValue ? 1 : 0;
                      });
                    }
                    setParentState(clone);
                  }}
                />
              );
            }
            return (
              <div key={syncFrequencyOption.en_field_label}>
                {syncFrequencyOption.en_field_label}
              </div>
            );
          })}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default SyncFrequencySetting;
